<template>
  <div class="assembly">
    <Header />
    <div
      class="assembly-content"
      :class="[
        $route.path.split('/')[1] === 'user' ? 'use-lanhu-bg-color' : '',
      ]"
    >
      <Bread />
      <keep-alive>
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Bread from "@/components/Bread.vue";
import Footer from "@/components/Footer.vue";
export default {
  data() {
    return {};
  },
  components: { Header, Bread, Footer },
  methods: {
    btn() {
      this.$router.push("/assembly/index");
    },
  },
  //使用beforeRouteUpdate 导航位置监听路由变化
  beforeRouteUpdate(to, from, next) {
    next();
  },
};
</script>
<style scoped lang='scss'>
.assembly {
  .assembly-content {
    min-height: calc(100vh - 270px);
    background: #fbfbfb;
    &.use-lanhu-bg-color {
      background-color: #f2f2f2;
    }
  }
}
</style>
